<template>
  <div
    style="
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-top: 50px;
    "
  >
    <div style="width: 100%">
      <div class="page-title-container">
        <p class="title-container">GESTIONE COLLI IN USCITA</p>
      </div>
      <div class="table-container">
        <ColliUscitaTable />
      </div>
    </div>
    <div
      id="form-position"
      class="form-container"
      v-if="
        this.store.state.global.showModificaColloState ||
        this.store.state.global.showEliminaColloState ||
        this.store.state.global.showScansioniColloState ||
        this.store.state.colliUscitaEntrata.showScansionaColliUscitaFormState
      "
    >
      <ModificaCollo
        v-if="this.store.state.global.showModificaColloState"
        :collo="this.store.state.global.editingCollo"
      />
      <EliminaCollo
        v-if="this.store.state.global.showEliminaColloState"
        :collo="this.store.state.global.editingCollo"
      />
      <ScansioniCollo
        v-if="this.store.state.global.showScansioniColloState"
        :ldv="this.store.state.global.ldvScansioni"
        :scansioni="this.store.state.global.scansioni"
      />
      <ScansionaColliUscitaForm
        v-if="
          this.store.state.colliUscitaEntrata.showScansionaColliUscitaFormState
        "
      />
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import ColliUscitaTable from "../components/ColliUscitaTable.vue";
import ModificaCollo from "../components/ModificaCollo.vue";
import EliminaCollo from "../components/EliminaCollo.vue";
import ScansioniCollo from "../components/ScansioniCollo.vue";
import ScansionaColliUscitaForm from "../components/ScansionaColliUscitaForm.vue";
const axios = require("axios");
export default {
  name: "ColliUscitaView",

  components: {
    ColliUscitaTable,
    ModificaCollo,
    EliminaCollo,
    ScansioniCollo,
    ScansionaColliUscitaForm,
  },

  setup() {
    const store = useStore();
    return {
      store,
    };
  },
};
</script>

<style scoped>
.page-title-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.title-container {
  font-size: 2rem;
  letter-spacing: 2px;
}

.table-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.form-container {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  background-color: rgba(0, 0, 0, 0.25);
}

#form-position {
  position: absolute;
  z-index: 4 !important;
}

.v-btn--variant-outlined {
  border: thin solid #d0d0d0;
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2);
}
</style>
